import { render, staticRenderFns } from "./batchConfiguration.vue?vue&type=template&id=16fea3d4&"
import script from "./batchConfiguration.vue?vue&type=script&lang=js&"
export * from "./batchConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports